import { Flex, Skeleton } from '@chakra-ui/react';

import { Table, TableProps } from '~/core/shared/components/Table';

export const ReactTable = <D extends Record<string, any>>(
  props: TableProps<D>,
) => (
  <Flex gap={4}>
    <Table
      loadingElement={
        <Flex direction="column" gap={4}>
          <Skeleton height={8} />
          <Skeleton height={8} />
          <Skeleton height={8} />
        </Flex>
      }
      {...props}
    />
  </Flex>
);
